// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tileList-root-xL4 {\n    display: grid;\n    gap: 1rem;\n    grid-auto-flow: column;\n    grid-template-columns: repeat(auto-fit, minmax(3rem, -webkit-max-content));\n    grid-template-columns: repeat(auto-fit, minmax(3rem, max-content));\n}\n\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "tileList-root-xL4"
};
export default ___CSS_LOADER_EXPORT___;
